import { Component } from "react";
import { estadosSolicitudCambio } from "../../../constantes/estadosSolicitud";
import DetalleSolicitudCambioCic from "./DetalleSolicitudCambioCic";
import servicioUsuario from "../../../servicios/servicioUsuario";
import { nombreDeRol } from "../../../constantes/nombreDeRol";
import AprobarSolicitudModal from "./Acciones/AprobarSolicitudModal";
import RechazarSolicitudModal from "./Acciones/RechazarSolicitudModal";
import EliminarSolicitudModal from "./Acciones/EliminarSolicitudModal";
import StickyTopBox from "../../Comunes/StickyBox/StickyTopBox";

export default class DetalleSolicitudCambioCicConAcciones extends Component {
  render() {
    let detalleSolicitud = this.props.DetalleModificarSolicitud;

    return (
      <div>
        <StickyTopBox>
          <div className="row">
            <div className="col-auto">
              <button
                type="button"
                onClick={() =>
                  this.props.VolverAVerResultados({
                    vuelvePorBotonRegresar: true,
                  })
                }
                className="btn btn-sm btn-primary"
              >
                <i className="fas fa-arrow-circle-left"></i>
              </button>
            </div>
            <div className="col">
              <h1 className="h3 mb-0 text-gray-800">Detalle de la Solicitud</h1>
            </div>
            <div className="col">
              <div className="text-right">
                {servicioUsuario.tieneRol(nombreDeRol.CambiosCicAprobar) &&
                (detalleSolicitud.estado.codigo ===
                  estadosSolicitudCambio.REGISTRADA ||
                  detalleSolicitud.estado.codigo ===
                    estadosSolicitudCambio.APROBADA_PARCIALMENTE) ? (
                  <>
                    <AprobarSolicitudModal
                      solicitud={detalleSolicitud}
                      regresarAListaSolicitudes={
                        this.props.VolverAVerResultados
                      }
                    />

                    <RechazarSolicitudModal
                      solicitud={detalleSolicitud}
                      regresarAListaSolicitudes={
                        this.props.VolverAVerResultados
                      }
                    />
                  </>
                ) : null}

                {servicioUsuario.tieneRol(nombreDeRol.CambiosCicSolicitar) &&
                (detalleSolicitud.estado.codigo ===
                  estadosSolicitudCambio.REGISTRADA ||
                  detalleSolicitud.estado.codigo ===
                    estadosSolicitudCambio.APROBADA_PARCIALMENTE) ? (
                  <>
                    <EliminarSolicitudModal
                      solicitud={detalleSolicitud}
                      regresarAListaSolicitudes={
                        this.props.VolverAVerResultados
                      }
                    />
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </StickyTopBox>

        <DetalleSolicitudCambioCic 
        detalleSolicitud={detalleSolicitud} />
      </div>
    );
  }
}
